module.exports = __webpack_public_path__ + "static/media/wp-en-3.1da99756.png";